import {
    FETCH_DEEPANALYSIS_QUESTIONS_SUCCESS_ACTION,
    FETCH_QNAIREANALYSIS_QUERY_SUCCESS_ACTION,
    FETCH_CUSTOM_QUERIES_SUCCESS_ACTION,
    ADD_CUSTOMANALYSIS_QUERY_ACTION,
    DELETE_CUSTOMANALYSIS_QUERY_ACTION,
    CLEAR_DEEPANALYSIS_QUERY_ACTION,
    SET_SELECTED_CUSTOM_QUERY_ACTION,
    FETCH_CROSSTABLE_DATA_SUCCESS_ACTION,
    SAVE_CROSS_TABLE_QUESTIONS_SUCCESS,
    FETCH_CROSSTABLE_S3_DATA_SUCCESS_ACTION,
    FETCH_CROSSTABLE_S3_DATA_ERROR_ACTION,
    FETCH_CROSSTABLE_S3_DATA_LOADING_ACTION,
    CLEAR_CROSSTABLE_S3_DATA_ACTION,
} from '../actions/deepanalysisActions';

export const DeepAnalysisReducer = (state = [], action) => {
    switch (action.type) {
        case FETCH_DEEPANALYSIS_QUESTIONS_SUCCESS_ACTION:
            const newQuestions = action.payload;
            return newQuestions;
        default:
            return state;
    }
};

export const DeepAnalysisQueriesReducer = (state = [], action) => {
    switch (action.type) {
        case FETCH_CUSTOM_QUERIES_SUCCESS_ACTION:
            const queries = action.payload;
            return queries;
        case ADD_CUSTOMANALYSIS_QUERY_ACTION:
            const clonedState = [...state];
            clonedState.push(action.payload);
            return clonedState;
        case DELETE_CUSTOMANALYSIS_QUERY_ACTION:
            const deletedQuery = action.payload;
            return state.filter(query => query.id !== deletedQuery.id);
        case CLEAR_DEEPANALYSIS_QUERY_ACTION:
            return [];
        default:
            return state;
    }
};

export const DeepAnalysisQuestionsReducer = (state = [], action) => {
    switch (action.type) {
        case FETCH_QNAIREANALYSIS_QUERY_SUCCESS_ACTION:
            const newQuery = action.payload;
            return newQuery;
        case CLEAR_DEEPANALYSIS_QUERY_ACTION:
            return [];
        default:
            return state;
    }
}
export const SelectedCustomQueryReducer = (state = null, action) => {
    switch (action.type) {
        case SET_SELECTED_CUSTOM_QUERY_ACTION:
            return action.payload;
        case CLEAR_DEEPANALYSIS_QUERY_ACTION:
            return null;
        default:
            return state;
    }
};

export const CrossTableDataReduce = (state = false, action) => {
    switch (action.type) {
        case FETCH_CROSSTABLE_DATA_SUCCESS_ACTION:
            const fetchedData = action.payload;
            return fetchedData;
        case SAVE_CROSS_TABLE_QUESTIONS_SUCCESS:
            const updatedData = action.payload;
            return updatedData;
        default:
            return state;
    }
};

export const CrossTableS3DataReducer = (state = { loading: false, data: null, error: null }, action) => {
    switch (action.type) {
        case FETCH_CROSSTABLE_S3_DATA_LOADING_ACTION:
            return {
                ...state,
                loading: true,
                error: null
            };
        // case FETCH_CROSSTABLE_S3_DATA_SUCCESS_ACTION:
        //     return {
        //         loading: false,
        //         data: action.payload,
        //         error: null
        //     };
        case FETCH_CROSSTABLE_S3_DATA_SUCCESS_ACTION:
            const newQuery = action.payload;
            return newQuery;
        case FETCH_CROSSTABLE_S3_DATA_ERROR_ACTION:
            return {
                loading: false,
                data: null,
                error: action.payload
            };
        case CLEAR_CROSSTABLE_S3_DATA_ACTION:
            return {
                loading: false,
                data: null,
                error: null
            };
        case CLEAR_DEEPANALYSIS_QUERY_ACTION:
            return {
                loading: false,
                data: null,
                error: null
            };
        default:
            return state;
    }
};
